/**
 * title -> string = titulo
 * subtitle -> object {label, {linkLabe, linkValue} }= subtitulo
 * width -> string = largura do card
 * maxWidth -> string = largura maxima do card
 * backgroundColor -> string = baclground do card
 */
import React from "react";
import './CardInfoIcon.css'
import { Link } from "react-router-dom";
const CardTreatment = (props) => {
    const {width, maxWidth, backgroundColor} = props
    return (
        <div className="container-card-structure-btu container-card-treatment" style={{
            ...(width ? {width} : {}),
            ...(maxWidth ? {maxWidth} : {}),
            ...(backgroundColor ? {backgroundColor} : {}),
        }}>
        </div>
    )
}

export default CardTreatment